import { NuqsAdapter } from '@vrplatform/query-params';
import * as Sentry from '@sentry/react';
import { useMemo } from 'react';
import { RouterProvider } from 'react-router/dom';
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router';
import { Auth } from './Auth';
import { RouteErrorElement } from './RouteErrorElement';

export function BrowserRouter() {
  const router = useMemo(() => {
    // Call this AFTER Sentry.init()
    const sentryCreateBrowserRouter =
      Sentry.wrapCreateBrowserRouter(createBrowserRouter);

    return sentryCreateBrowserRouter(
      createRoutesFromElements(
        <Route
          path="*"
          errorElement={<RouteErrorElement />}
          element={
            <NuqsAdapter>
              <Auth />
            </NuqsAdapter>
          }
        />
      )
    );
  }, []);

  return <RouterProvider router={router} />;
}
